// Cyprus and Russia route to Europe; Turkey and the Caucasus route to Asia.
const REGIONS = Object.freeze({
  Europe: new Set("AX AL AD AT BY BE BA BG HR CY CZ DK EE FO FI FR DE GI GR GG HU IS IE IM IT JE XK LV LI LT LU MT MD MC ME NL MK NO PL PT RO RU SM RS SK SI ES SJ SE CH UA GB VA".split(" ")),
  Asia: new Set("AF AM AZ BH BD BT BN KH CN GE HK IN ID IR IQ IL JP JO KZ KP KR KW KG LA MO MY MV MN MM NP OM PK PS PH QA SA SG LK SY TW TJ TH TL TR TM AE UZ VN YE".split(" ")),
  America: new Set("AI AG AR AW BS BB BZ BM BQ VG KY BO BR CA CL CO CR CU CW DM DO EC SV FK GF GL GD GP GT GY HT HN JM MQ MX MS NI PA PY PE PR BL KN LC MF PM VC SX SR TT TC US UY VE VI".split(" ")),
  Etc: new Set("DZ AO BJ BW BF BI CV CM CF TD KM CG CD CI DJ EG GQ ER SZ ET GA GM GH GN GW KE LS LR LY MG MW ML MR MU YT MA MZ NA NE NG RE RW SH ST SN SC SL SO ZA SS SD TN TZ TG UG EH ZM ZW AQ AS AU BV IO CC CX CK NF HM TF FJ PF GU KI MH FM NR NC NZ NU MP PW PG PN WS SB GS TK TO TV UM VU WF".split(" ")),
});

const KNOWN_COUNTRIES = new Set(Object.values(REGIONS).flatMap((codes) => [...codes]));

export function normalizeSalesCountry(value) {
  const country = String(value || '').trim().toUpperCase();
  return country.length === 2 && KNOWN_COUNTRIES.has(country) ? country : '';
}

export function getSalesRegion(country) {
  const code = normalizeSalesCountry(country);
  if (!code) return null;
  return Object.keys(REGIONS).find((region) => REGIONS[region].has(code)) || null;
}

export function getRegionalSalesAdminId(country) {
  return getSalesRegion(country);
}

